// 字段排序函数
// const compare = property => {
//   return function (a, b) {
//     var value1 = a[property];
//     var value2 = b[property];
//     return value1 - value2;
//   };
// };

// 获取排序后的列表
// export const orderGoodsList = state => {
//   return state.goodsList;
// };


// 获取父级上溯
const findAncestry = (arr, id) => {
  var temp = []
  var forFn = (list, id) => {
    for (var i = 0; i < list.length; i++) {
      var item = list[i]
      if (item.id == id) {
        temp.push(item)
        forFn(arr, item.parentId)
        break
      } else {
        if (item.children) {
          forFn(item.children, id)
        }
      }
    }
  }
  forFn(arr, id)

  // 倒序返回
  let tempNew = []
  for(var i= temp.length-1; i>=0; i--){ 
    tempNew.push(temp[i])
  }
  return tempNew
}

// 追溯获取当前等级数据
const findChildren = (arr, id) => {
  var tmp = []
  var forFn = (list, id) => {
    for (var i = 0; i < list.length; i++) {
      var item = list[i]
      if (item.id == id) {
        tmp = item
        break
      } else {
        if (item.children) {
          forFn(item.children, id)
        }
      }
    }
  }
  forFn(arr, id)
  return tmp
}

// 下级分类
export const subClassifyList = state => {

  var list = findAncestry(state.classifyList, state.currentClassifyId)
  let tmp = state.classifyList.filter(item => item.id == list[0].id)
  return tmp[0] && tmp[0].children;
  // var tmp = findChildren(state.classifyList, state.currentClassifyId)
  // return tmp && tmp.children;
};

// 获取面包屑
export const breadCrumbList = state => {
  return findAncestry(state.classifyList, state.currentClassifyId);
};





// WEBPACK FOOTER //
// ./src/store/getters.js